export default __webpack_public_path__ + "static/media/artGallery.018b0ddb.png";